import * as React from 'react';
import classNames from 'classnames/bind';
import { Icon } from '../Icon';

import css from './avatar.module.css';

const cx = classNames.bind(css);

type Props = {
  src: string;

  fullName: string;

  showEdit?: boolean;

  size?: 'small' | 'large';

  onClick?: () => void;

  className?: string;
};

/**
 * Primary UI component for user interaction
 */
export const Avatar: React.FC<Props> = props => {
  const { src, fullName, size, showEdit, onClick, className } = props;

  return (
    <div
      onClick={() => onClick?.()}
      className={cx('avatar', size, { 'edit-frame': showEdit }, className)}
    >
      <img className={cx('img')} src={src} alt={fullName} />
      {showEdit ? (
        <Icon size="0.7em" color="#fff" className={cx('edit')} name="camera" />
      ) : null}
    </div>
  );
};

Avatar.defaultProps = {
  showEdit: false,
  size: 'small',
};
